import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function AssemblyCommissioning() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-f13a7513b1d94a9ca64d009f1172fcf7-mv2.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/automatiske-maskiner-montage.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/elkonstruktion-styretavle.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/produktionsudstyr-specialmaskine.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Montage og indkøring - JARCon ApS"
        description="Montage og indkøring af maskiner og delkomponenter mekanisk og elektrisk."
      />

      <PageHeader
        badge="Konsulentydelser"
        title="Montage og indkøring"
        subtitle="Montage og indkøring af maskiner og delkomponenter • mekanisk og elektrisk"
        breadcrumbs={[
          { label: 'Konsulentydelser', path: '/konsulentydelser' },
          { label: 'Montage og indkøring' },
        ]}
        ctaText="Hør mere om montagehjælp"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Praktisk maskinerfaring
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Mekanisk og elektrisk montage og indkøring
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Montage og indkøring af maskiner og delkomponenter - mekanisk og elektrisk.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Når nye maskiner skal samles eller eksisterende anlæg ombygges, er det afgørende, at mekanik, hydraulik, pneumatik og elektrisk styring fungerer optimalt sammen. Med udgangspunkt i mange års erfaring fra maskinfabrikker og produktionsanlæg tager vi hånd om hele montage- og testfasen.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-wrench" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">Mekanisk montage</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Præcis opretning, montering af lejer, aksler, gear, lineærføringer og pneumatiske cylindre med fokus på driftsstabilitet og minimal friktion.
                </p>
              </div>

              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-bolt" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">Elektrisk indkøring</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Signaltjek, kalibrering af sensorer, I/O-test, test af sikkerhedskredsløb og finjustering af servodrev og motorstyringer.
                </p>
              </div>
            </div>

            <GalleryGrid
              title="Montage og maskinkomponenter galleri"
              subtitle="Se eksempler på mekaniske komponenter og montage"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Ydelsesoversigt
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Mekanisk montage af delkomponenter</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Elektrisk fortrådning og tilslutning</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Funktionstest og parameterindstilling</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Fejlfinding og optimering på stedet</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Produktionsadresse: Huholt 1A, 6400 Sønderborg</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Planlægger du idriftsættelse?
              </span>
              <p className="text-xs text-slate-300">
                Kontakt JARCon for assistance ved montage og mekanisk/elektrisk indkøring.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
